import { IDocsStats } from '../../../../interfaces/account/IDocsStats';
import Button from '../../../../shared/button';
import Modal from '../../../../shared/modal';
import { useProductTeamStatisticsDownloadMutation } from '../../../../store/chatbox/chatboxApi';

const ReportedIssuesModal = ({
    openModal,
    handleCloseModal,
    data,
    hotelId,
}: {
    openModal: boolean;
    handleCloseModal: () => void;
    data?: IDocsStats;
    hotelId: string;
}) => {
    const [downloadReport, { isLoading }] =
	useProductTeamStatisticsDownloadMutation();
    const handleDownloadReport = async () => {
        try {
            const res = await downloadReport({
                hotelId,
                sourceName: data?.topic,
            }).unwrap();

            const { excelLink } = res.data;
            const response = await fetch(excelLink);
            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);

            const a = document.createElement('a');
            a.href = url;
            a.download = `${data?.topic.split('.')[0]}.xlsx`; // Optional: rename the downloaded file
            document.body.appendChild(a);
            a.click();
            a.remove();

            window.URL.revokeObjectURL(url);
        } catch (e) {
            console.error({ e });
        }
    };
    return (
        <Modal
            open={openModal}
            contentContainerStyle="lg:min-w-[900px] rounded-2xl"
            title="Reported issues "
            onClose={handleCloseModal}>
            <div className="max-h-96 overflow-y-auto">
                <table className="w-full" border={1}>
                    <thead className="border-b">
                        <tr className="text-[#1C1C1C66] text-opacity-40 ">
                            <td className=" pb-2">Questions</td>
                            <td>Agent</td>
                        </tr>
                    </thead>
                    <tbody>
                        {Array.isArray(data?.allInfo)
                            ? data?.allInfo.map((row, i: number) => (
                                  <tr key={i}>
                                      <td className="p-2 border-b border-[#1C1C1C0D] border-opacity-5 text-gray-900 text-xs">
                                          {row.data.question}
                                      </td>
                                      <td className="p-2 border-b border-[#1C1C1C0D] border-opacity-5 text-gray-900 text-xs">
                                          {row.data.agent}
                                      </td>
                                  </tr>
                              ))
                            : []}
                    </tbody>
                </table>
            </div>
            <div className="pt-5 flex flex-wrap w-full">
                <Button
                    loading={isLoading}
                    onClickButton={handleDownloadReport}
                    className="rounded-2xl py-2 px-5 border border-gray-800 hover:bg-gray-400 hover:text-white ml-auto"
                    label="Download full report .csv"
                />
            </div>
        </Modal>
    );
};

export default ReportedIssuesModal;
